(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    const deaconsAnimations = new WeakMap();
function animateDeaconsMenu(menu, opening) {
  const panel = menu.querySelector('.deacons-menu-panel');
  const previous = deaconsAnimations.get(menu);
  if (previous) previous.cancel();
  menu.classList.toggle('deacons-closing', !opening);
  if (opening) menu.open = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { menu.open = opening; menu.classList.remove('deacons-closing'); return; }
  const frames = [{clipPath:'inset(0 0 100% 0)', opacity:0}, {clipPath:'inset(0 0 0% 0)', opacity:1}];
  const animation = panel.animate(opening ? frames : frames.slice().reverse(), {duration:420, easing:'cubic-bezier(.22,1,.36,1)', fill:'both'});
  deaconsAnimations.set(menu, animation);
  animation.onfinish = () => { if (!opening) menu.open = false; menu.classList.remove('deacons-closing'); animation.cancel(); deaconsAnimations.delete(menu); };
}
document.addEventListener('click', event => {
  const summary = event.target.closest('.deacons-shop-menu > summary');
  if (summary) { event.preventDefault(); const menu = summary.parentElement; animateDeaconsMenu(menu, !menu.open || menu.classList.contains('deacons-closing')); return; }
  document.querySelectorAll('.deacons-shop-menu[open]').forEach(menu => { if (!menu.contains(event.target)) animateDeaconsMenu(menu, false); });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.deacons-shop-menu[open]').forEach(menu => { animateDeaconsMenu(menu, false); menu.querySelector('summary').focus(); });
});
  } catch(e) { console.error(e); }
})();

})();
